import APITemplate from '@api/APITemplate'
import store from '@state/store'
import con from '@services/connection'
import { intelligenceV2 } from '@modules/aawz-intelligence-v2/constants/URL'
import { ID_SEM_MODELO } from '@modules/aawz-intelligence-v2/utils/modelos-suportados'

// ⚠️ Fallback SEM id de modelo (Q7-A08, 03/09/2026): a rota falhou, então o
// front não sabe qual modelo existe — inventar um id aqui é como o
// `claude-sonnet-4-6` sobreviveu meses depois de sair da lista do backend.
// Lista vazia faz `modeloValidoOuPadrao` preservar a escolha atual em vez de
// trocá-la por um palpite.
const FALLBACK = { default: ID_SEM_MODELO, models: [] }

class APISupportedModels extends APITemplate {
  async fetch() {
    try {
      const r = await con.get(intelligenceV2.supportedModels)
      if (r && r.status === 200 && r.value) {
        return r.value
      }
      return FALLBACK
    } catch (e) {
      console.warn('[ia-crm] supportedModels fallback (rede/parsing falhou)', e)
      return FALLBACK
    }
  }

  // Lê a lista e PERSISTE no slice pedido (molde de `apiConversations.carregar`): a action
  // Vuex nunca busca — o `loadSupportedModels` de cada superfície só repassa para cá,
  // e o `setSupportedModels` dela é quem reconcilia o `localStorage`.
  async carregarPara({ storeModule } = {}) {
    if (!storeModule) {
      throw new Error(
        'storeModule obrigatório em carregarPara: recebido ' + String(storeModule) +
          ', esperado o namespace Vuex da superfície (ex.: "feeFixoIa").'
      )
    }
    const dados = await this.fetch()
    store.dispatch(storeModule + '/setSupportedModels', dados)
    return dados
  }
}

export const apiSupportedModels = new APISupportedModels()
